import React from "react"

const MarketsSelected = () => (
    <div className="travel__selected">
        <div className="container">
            <div className="has-text-white travel__selected--columns">
                <div className="info has-text-centered px-0 mx-0">
                    <p className="pb-5">
                        Put your business on the map, take your client home, or
                        to their frequent destinations abroad.
                    </p>
                    <p className="pb-5">
                        Increase your travel-related benefits in a broad network
                        of top airports and seaports in the world.
                    </p>
                </div>
            </div>
        </div>
    </div>
)

export default MarketsSelected
